import mailSyncStatus from '../../../../../../vendor/inbox/mailsync-form/src/Resources/js/mail-sync-status';

const initialize = () => {
    mailSyncStatus();
};
export default initialize;
